/**
 * ニュースページ固有の機能
 */

/**
 * ニュースページの初期化とイベント設定
 */
function initializeNewsPage() {
  const backFixmenu = new FixMenu($(".back"));
  backFixmenu.init();
}

imagesLoaded(document.querySelector(".wrap"), function() {
  init();
  setupCommonEventListeners();
  initializeNewsPage();
});
